import { NotificationsContext } from "@via/context/notifications-context.tsx";
import { useContext } from "react";
export function useNotifications(): any {
  return useContext(NotificationsContext);
}
